<template>
	<cTable :fields="fields" :header="header" :methods="methods" :modals="modals" :footer="footer" :config="config">
		
	</cTable>
</template>

<script>
	import {
	  getList,
		update,
		apis,
	} from "@/api/system/clientConfig";
	import { getAllClient, getDetails } from "@/api/user/client";
	import cTable from "@/base/common/index";
	export default {
		name:'clientConfig',
		components:{
			cTable
		},
		async mounted() {
			// let client = (await getAllClient()).data.payload.rows;
			// this.modals.add.fields.forEach(t=>{
			// 	if(t.key === 'id')t.options = client
			// })
			// this.header.searchs.forEach(t=>{
			// 	if(t.key === 'client_id')t.options = client
			// })
		},
		data() {
			return {
				config:{
				},
				methods:{
					list:getList,
					update,
				},
				footer:{
				},
				header:{
					searchs:[
						// {
						//   key: "client_id",
						//   placeholder() {
						//     return this.$t("select") + this.$t("clientName");
						//   },
						//   component: "Select",
						//   options: [],
						//   config: { label: "account", value: "id" },
						// },
						// {
						// 	key: 'client_id',
						// 	placeholder() {
						// 		return this.$tz('请选择,客户名称')
						// 	},
						// 	component: 'Select',
						// 	options: [],
						// 	optionsFn: 'getAllClient',
						// 	optionsKey: '',
						// },
					],
					btns:{
						list:[
							{
								name:this.$t('add'),
								type:'add',
								fnName:'add',
								bind:{
									type:'primary'
								}
							}
						],
						methods:{
							add(){
								this.getModal('add').open(null,function(){
									this.type = 'add'
									this.setTitle('add')
								})
							},
						}
					}
				},
				modals:{
					add:{
						methods:{
							ok({row,close}){
								this.$page.handleRequestMethods('update',row,true,true).then(_=>this.$page.getList(),close())
							}
						},
						config: {
							title: this.$t("add"),
							modalBind: {
								width: 600,
								draggable: true
							},
							formBind: {
								labelWidth: 120
							},
							colBind: {
								style: {
									marginBottom: "20px"
								}
							},
							rules:{
								id: [
								  {
								    required: true,
								    type: "number",
								    message: "Please select the Client Name",
								    trigger: "change",
								  },
								],
							}
						},
						grid: [
							{
								id:24,
								send_tracker_url:24,
								revoke_tracker_url:24,
								authorization:24,
							},
						],
						fields: [
							{
								name: () => this.$t("userInfoStr2"),
								placeholder:this.$t('userInfoStr2'),
								key: "send_tracker_url",
								component: "Input",
							},
							{
								name: () => this.$t("userInfoStr3"),
								placeholder:this.$t('userInfoStr3'),
								key: "revoke_tracker_url",
								component: "Input",
							},
							{
								name: () => this.$t("authorization"),
								placeholder:this.$t('authorization'),
								key: "authorization",
								component: "Input",
							},
							{
							  key: "id",
								name: () => this.$t("clientName"),
							  placeholder() {
							    return this.$t("clientName");
							  },
								show(){
									return this.$modal.type == 'add'
								},
							  component: "Select",
							  options: [],
								optionsFn:'getAllClient',
								methods:{
									'on-change'({value,formData}){
										getDetails(value).then(res=>{
											if(res.data.status){
												formData.authorization = res.data.payload.authorization
											}
										})
									}
								}
							},
							// {
							//   key: "id",
							// 	name: () => this.$t("clientName"),
							//   placeholder() {
							//     return this.$t("clientName");
							//   },
							// 	show(){
							// 		return this.$modal.type == 'add'
							// 	},
							//   component: "Select",
							//   options: [],
							//   config: { label: "account", value: "id" },
							// 	methods:{
							// 		'on-change'({value,formData}){
							// 			getDetails(value).then(res=>{
							// 				if(res.data.status){
							// 					formData.authorization = res.data.payload.authorization
							// 				}
							// 			})
							// 		}
							// 	}
							// },
						]
					}
				},
				fields:[
					{
						name:()=>this.$t("clientName"),
						key:"account",
						minWidth:130,
					},
					{
						name:()=>this.$t("userInfoStr2"),
						key:"send_tracker_url",
						minWidth:130,
					},
					{
						name:()=>this.$t("userInfoStr3"),
						key:"revoke_tracker_url",
						minWidth:130,
					},
					{
						name:()=>this.$t("authorization"),
						key:"authorization",
						minWidth:130,
					},
					{
						type: "btns",
						width: 150,
						name: () => this.$t("operation"),
						fixed: "right",
						list: [
							{
								name: () => this.$t("update"),
								type: "update",
								fnName: "updateFun",
								bind: {
									type: "success",
								},
							},
						],
						methods: {
							async updateFun({ row }) {
								this.getModal('add').open(row,function(){
									this.type = 'update'
									this.setTitle(this.$t("update"));
								})
							 
							},
							deleteFun({ row }) {
								this.$Modal.confirm({
									title:
										this.$t("whether") +
										this.$t("confirm") +
										this.$t("delete"),
									onOk: () => {
										this.handleRequestMethods("del", row, true).then((res) => {
											// this.$Message.success(res.data.msg);
											this.getList();
										});
									},
								});
							},
						},
					}
				]
			}
		},
	}
</script>

<style scoped>

</style>